import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const SimpleCameraIcon = withTheme(
  ({ title, theme, width, height, viewBox = "0 0 50 50", type }) => (
    <svg
      width={width}
      height={height}
      title={title}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
    >
      <path
        d="M1.63339 4.18685H4.65472V3.72792C4.65472 3.15425 5.11365 2.69531 5.68732 2.69531H10.3723C10.946 2.69531 11.4049 3.15425 11.4049 3.72792V4.18685H14.4262C15.2102 4.18685 15.8604 4.83701 15.8604 5.62103V13.4229C15.8604 14.2069 15.2102 14.8571 14.4262 14.8571H1.63339C0.849378 14.8571 0.199219 14.2069 0.199219 13.4229V5.62103C0.199219 4.81789 0.849378 4.18685 1.63339 4.18685Z"
        fill={
          type === "alternative" ? theme.onPrimaryColor : theme.primaryColor
        }
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7543 6.80668C10.0659 6.09916 9.09063 5.67847 8.0389 5.67847C6.98717 5.67847 6.01193 6.09916 5.32353 6.80668C4.616 7.49509 4.19531 8.47032 4.19531 9.52205C4.19531 10.5738 4.63513 11.549 5.32353 12.2374C6.01193 12.9449 6.98717 13.3656 8.0389 13.3656C9.09063 13.3656 10.0659 12.9258 10.7543 12.2374C11.4618 11.549 11.8825 10.5738 11.8825 9.52205C11.8825 8.47032 11.4427 7.49509 10.7543 6.80668ZM8.0389 6.4816C8.88028 6.4816 9.64517 6.80668 10.1997 7.36123C10.7351 7.91578 11.0793 8.68067 11.0985 9.54117C11.0985 10.3826 10.7543 11.1474 10.1997 11.702C9.64517 12.2565 8.88028 12.6007 8.0389 12.6007C7.19752 12.6007 6.43262 12.2565 5.87808 11.702C5.32353 11.1474 4.97933 10.3826 4.97933 9.54117C4.97933 8.69979 5.32353 7.9349 5.87808 7.38035C6.43262 6.82581 7.19752 6.4816 8.0389 6.4816Z"
        fill={
          type !== "alternative" ? theme.onPrimaryColor : theme.primaryColor
        }
      />
      <circle
        cx="13.6223"
        cy="6.40503"
        r="0.764893"
        fill={
          type !== "alternative" ? theme.onPrimaryColor : theme.primaryColor
        }
      />
      <circle
        cx="8.039"
        cy="9.52191"
        r="2.10345"
        fill={
          type !== "alternative" ? theme.onPrimaryColor : theme.primaryColor
        }
      />
    </svg>
  )
);

export const CameraIcon = ({ width = "16", height = "17", type, title }) => (
  <Icon>
    <SimpleCameraIcon
      width={width}
      height={height}
      viewBox="0 0 16 17"
      title={title}
      type={type}
    />
  </Icon>
);

CameraIcon.propTypes = {
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  title: PropTypes.string
};

CameraIcon.defaultProps = {
  title: "Camera Icon",
  type: "secondary"
};

export default withTheme(CameraIcon);
